import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import ContentDialog from '../../core/dialog/ContentDialog';

export interface ILicenseUpgradeDialogProps {
    open: boolean;
    onClose: () => void;
    orgId: string;
    canManageBilling?: boolean;
}

export default function MaxSeatsDialog({ open, onClose, orgId, canManageBilling = false }: ILicenseUpgradeDialogProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { currentOrg } = useCurrentOrgDetailsFetching();

    const onConfirm = () => {
        onClose();
        if (canManageBilling) {
            navigate(`/org/${orgId}/billing/redirect/upgrade`);
        }
    };

    return canManageBilling == true ? (
        <ContentDialog
            open={open}
            onClose={onClose}
            onCancel={onClose}
            title={t('common:organization.member.seats.updateLimit.title')}
            description={t('common:organization.member.seats.updateLimit.description', 'Limit reached', {
                maxSeats: currentOrg?.maxMembers,
            })}
            confirmButtonText={t('common:organization.member.seats.updateLimit.action')}
            onConfirm={onConfirm}
        />
    ) : (
        <ContentDialog
            open={open}
            onClose={onClose}
            title={t('common:organization.member.seats.limit.title')}
            description={t('common:organization.member.seats.limit.description', 'Limit reached', {
                maxSeats: currentOrg?.maxMembers,
            })}
            confirmButtonText={t('common:close')}
            onConfirm={onConfirm}
        />
    );
}
